import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CERTIFICATES_FEATURE_KEY } from '../keys';
import { CertificatesState } from '../reducers/certificates.reducer';

const selectState = createFeatureSelector<CertificatesState>(CERTIFICATES_FEATURE_KEY);

export const selectCertificates = createSelector(selectState, (state: CertificatesState) => state.certificates.data);
export const selectCertificatesLoaded = createSelector(selectState, (state: CertificatesState) => state.certificates.loaded);
export const selectCertificatesLoading = createSelector(selectState, (state: CertificatesState) => state.certificates.loading);
